// Copyright (c) 2024, Quantum Xchange
'use strict'

const { darken, lighten } = require('polished')

const primaryColor = '#5f61ff'
const secondaryColor = '#ffffff'
const dangerColor = '#FF9371'
const successColor = '#00C46F'
const warningColor = '#FFC06C'
const infoColor = '#76D2FF'
const linkColor = primaryColor
const lightFontColor = '#E1E2E3'
const darkFontColor = '#1a1a1a'

const severirtyColors = {
    critical: dangerColor,
    high: warningColor,
    low: '#e1e2e3',
    medium: infoColor,
}

module.exports = {
    colors: {
        primary: primaryColor,
        secondary: secondaryColor,
        secondaryColor: '#a7a7a7',
        danger: dangerColor,
        success: successColor,
        warning: warningColor,
        info: infoColor,
        a: {
            color: primaryColor,
            hover: {
                color: lighten(0.2, primaryColor),
            },
        },
        accordion: {
            background: 'transparent',
            borderColor: `${darkFontColor}33`,
            color: darkFontColor,
            header: {
                afterColor: 'rgb(26, 26, 26)',
                beforeColor: 'rgba(26, 26, 26, 0.4)',
                color: darkFontColor,
                hover: {
                    afterColor: 'rgb(95, 97, 255)',
                },
                open: {
                    background: 'lightgrey',
                    color: darkFontColor,
                },
            },
        },
        alert: {
            danger: {
                background: dangerColor,
                border: `1px solid ${dangerColor}`,
                color: darkFontColor,
            },
            primary: {
                background: primaryColor,
                border: `1px solid ${primaryColor}`,
                color: lightFontColor,
            },
            secondary: {
                background: secondaryColor,
                border: `1px solid ${secondaryColor}`,
                color: lightFontColor,
            },
            success: {
                background: successColor,
                border: `1px solid ${successColor}`,
                color: darkFontColor,
            },
            warning: {
                background: warningColor,
                border: `1px solid ${warningColor}`,
                color: darkFontColor,
            },
            info: {
                background: infoColor,
                border: `1px solid ${infoColor}`,
                color: darkFontColor,
            },
        },
        avatar: {
            backgroundColor: '#d2a62d',
            borderColor: '#d2a62d',
            color: darkFontColor,
        },
        badge: {
            danger: {
                backgroundColor: dangerColor,
                borderColor: dangerColor,
                color: darkFontColor,
            },
            primary: {
                backgroundColor: primaryColor,
                borderColor: primaryColor,
                color: lightFontColor,
            },
            secondary: {
                backgroundColor: secondaryColor,
                borderColor: secondaryColor,
                color: darkFontColor,
            },
            success: {
                backgroundColor: successColor,
                borderColor: successColor,
                color: darkFontColor,
            },
            warning: {
                backgroundColor: warningColor,
                borderColor: warningColor,
                color: darkFontColor,
            },
            info: {
                backgroundColor: infoColor,
                borderColor: infoColor,
                color: darkFontColor,
            },
            critical: {
                backgroundColor: `${severirtyColors.critical}`,
                borderColor: severirtyColors.critical,
                color: darkFontColor,
            },
            high: {
                backgroundColor: `${severirtyColors.high}`,
                borderColor: severirtyColors.high,
                color: darkFontColor,
            },
            medium: {
                backgroundColor: `${severirtyColors.medium}`,
                borderColor: severirtyColors.medium,
                color: darkFontColor,
            },
            low: {
                backgroundColor: `${severirtyColors.low}`,
                borderColor: severirtyColors.low,
                color: darkFontColor,
            },
        },
        body: {
            background: '#e1e2e3',
            color: darkFontColor,
            dangerColor,
            successColor,
        },
        dropdown: {
            button: {
                secondary: {
                    active: {
                        background: 'transparent',
                        color: linkColor,
                    },
                },
            },
        },
        breadcrumbs: {
            background:
                'linear-gradient(117deg, #fff 32.24%, #f8f8f8 71.68%, #e7e7e9 111.13%) padding-box, linear-gradient(150deg, #fff 60%, #5161ff 100%) border-box',
            color: '#a7a7a7',
            hover: {
                color: primaryColor,
            },
            active: {
                color: darkFontColor,
            },
        },
        button: {
            primary: {
                backgroundColor: primaryColor,
                borderColor: primaryColor,
                color: lightFontColor,
                active: {
                    backgroundColor: `${primaryColor}DD`,
                    borderColor: primaryColor,
                    color: lightFontColor,
                },
                disabled: {
                    backgroundColor: `${primaryColor}80`,
                    borderColor: `${primaryColor}80`,
                    color: lightFontColor,
                },
                hover: {
                    backgroundColor: `${primaryColor}CC`,
                    borderColor: primaryColor,
                    color: lightFontColor,
                },
            },
            secondary: {
                backgroundColor: secondaryColor,
                borderColor: secondaryColor,
                color: darkFontColor,
                active: {
                    backgroundColor: secondaryColor,
                    borderColor: secondaryColor,
                    color: primaryColor,
                },
                disabled: {
                    backgroundColor: `${secondaryColor}80`,
                    borderColor: `${secondaryColor}80`,
                    color: darkFontColor,
                },
                hover: {
                    backgroundColor: secondaryColor,
                    borderColor: secondaryColor,
                    color: primaryColor,
                },
            },
            outlineSecondary: {
                backgroundColor: '#fff0',
                borderColor: '#1a1a1a66',
                color: '#1a1a1acc',
                active: {
                    backgroundColor: '#fff0',
                    borderColor: primaryColor,
                    color: primaryColor,
                },
                disabled: {
                    backgroundColor: `${secondaryColor}80`,
                    borderColor: `${secondaryColor}80`,
                    color: darkFontColor,
                },
                hover: {
                    backgroundColor: '#fff0',
                    borderColor: primaryColor,
                    color: primaryColor,
                },
            },
            light: {
                color: darkFontColor,
            },
            success: {
                backgroundColor: successColor,
                borderColor: successColor,
                color: darkFontColor,
                active: {
                    backgroundColor: successColor,
                    borderColor: successColor,
                    color: darkFontColor,
                },
                disabled: {
                    backgroundColor: `${successColor}80`,
                    borderColor: `${successColor}80`,
                    color: darkFontColor,
                },
                hover: {
                    backgroundColor: successColor,
                    borderColor: successColor,
                    color: primaryColor,
                },
            },
            danger: {
                backgroundColor: dangerColor,
                borderColor: dangerColor,
                color: lightFontColor,
                active: {
                    backgroundColor: dangerColor,
                    borderColor: dangerColor,
                    color: darkFontColor,
                },
                disabled: {
                    backgroundColor: `${dangerColor}80`,
                    borderColor: `${dangerColor}80`,
                    color: darkFontColor,
                },
                hover: {
                    backgroundColor: dangerColor,
                    borderColor: dangerColor,
                    color: primaryColor,
                },
            },
            link: {
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                color: darkFontColor,
                active: {
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: linkColor,
                },
                disabled: {
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: `${darkFontColor}80`,
                },
                hover: {
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    color: linkColor,
                },
            },
        },
        buttonGroup: {
            primary: {
                background: 'transparent',
                border: `1px solid ${primaryColor}`,
                color: primaryColor,
                boxShadow: `none`,
                active: {
                    background: primaryColor,
                    border: `1px solid ${primaryColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: primaryColor,
                    border: darken(0.1, primaryColor),
                    color: lightFontColor,
                },
                hover: {
                    background: 'transparent',
                    border: `1px solid ${primaryColor}`,
                    color: primaryColor,
                    boxShadow: `0px 0px 0px 2px #E0F7FA`,
                },
            },
            secondary: {
                background: 'transparent',
                border: `1px solid ${secondaryColor}`,
                color: secondaryColor,
                boxShadow: `none`,
                active: {
                    background: secondaryColor,
                    border: `1px solid ${secondaryColor}`,
                    color: lightFontColor,
                },
                disabled: {
                    background: secondaryColor,
                    border: darken(0.1, secondaryColor),
                    color: lightFontColor,
                },
                hover: {
                    background: 'transparent',
                    border: `1px solid ${secondaryColor}`,
                    color: secondaryColor,
                    boxShadow: `0px 0px 0px 2px #E0F7FA`,
                },
            },
        },
        card: {
            background: '#FFFc',
            borderColor: '#fffc',
            borderRadius: '0.75rem',
            color: darkFontColor,
            footer: {
                background: '#FFFc',
                border: '#FFFc',
                color: darkFontColor,
            },
            header: {
                background: '#FFFc',
                border: '#FFFc',
                color: darkFontColor,
            },
            highlight: {
                background:
                    'linear-gradient(117deg, #fff 32.24%, #f8f8f8 71.68%, #e7e7e9 111.13%) padding-box, linear-gradient(150deg, #fff 60%, #5161ff 100%) border-box',
                border: '1px solid transparent',
                borderRadius: '0.75rem',
            },
            inputList: {
                backgroundColor: `${primaryColor}0a`,
                borderColor: `${primaryColor}66`,
            },
        },
        charts: {
            backgroundColor: '#FFF',
            borderColor: '#d3d3d3',
            textColor: darkFontColor,
            axisColor: darkFontColor,
            tooltip: {
                backgroundColor: '#FFF',
                borderColor: '#1a1a1a14',
                boxShadow: '0 0 #0000, 0 0 #0000, 0 0 #0000, 0 0 #0000, 0.5rem 0.5rem 0.875rem 0rem #5f61ff4d',
                textColor: darkFontColor,
            },
            lightBlue: { backgroundColor: '#76d2ffe5', textColor: darkFontColor },
            blue: { backgroundColor: '#1c90e1e5', textColor: '#FFFFFF' },
            green: { backgroundColor: '#72cc56e5', textColor: '#4C4C4C' },
            orange: { backgroundColor: '#ffc06ce5', textColor: '#383838' },
            purple: { backgroundColor: '#5f61ffe5', textColor: '#FFFFFF' },
            teal: { backgroundColor: '#95ffece5', textColor: darkFontColor },
            red: { backgroundColor: '#ff9371e5', textColor: '#FFFFFF' },
            colorCollection: [
                { backgroundColor: '#1c90e1', textColor: lightFontColor },
                { backgroundColor: '#5f61ff', textColor: lightFontColor },
                { backgroundColor: '#76d2ff', textColor: lightFontColor },
                { backgroundColor: '#72cc56', textColor: darkFontColor },
                { backgroundColor: '#ffc06c', textColor: darkFontColor },
                { backgroundColor: '#7053c5', textColor: darkFontColor },
                { backgroundColor: '#ff9371', textColor: lightFontColor },
            ],
        },
        datePicker: {
            backgroundColor: '#ffffff',
            borderColor: '#1a1a1a33',
            color: darkFontColor,
            day: {
                hover: {
                    backgroundColor: primaryColor,
                    color: lightFontColor,
                },
            },
            disabled: {
                color: `${darkFontColor}80`,
            },
            selectedDay: {
                backgroundColor: `${primaryColor}99`,
                color: darkFontColor,
            },
            inSelectingRange: {
                backgroundColor: `${primaryColor}4d`,
                color: darkFontColor,
            },
            navigationIcon: {
                color: `${darkFontColor}cc`,
                hover: {
                    color: primaryColor,
                },
            },
        },
        dropdownMenu: {
            backgroundColor: '#FFFFFF',
            borderColor: '#1a1a1a14',
            item: {
                color: `${darkFontColor}b2`,
                active: {
                    background: '#FFFFFF',
                    color: '#000000',
                    fontWeight: '600',
                },
                disabled: {
                    color: `${darkFontColor}80`,
                },
                hover: {
                    backgroundColor: '#FFFFFF',
                    borderColor: '#1a1a1a14',
                    color: darkFontColor,
                },
            },
        },
        evidence: {
            backgroundColor: '#FEFEFE',
            borderBottom: '1px solid #E0E0E0',
            boxShadowColor: darkFontColor,
            color: darkFontColor,
        },
        formControl: {
            backgroundColor: '#ffffff',
            borderColor: '#1a1a1a33',
            boxShadow: 'none',
            color: darkFontColor,
            error: dangerColor,
            success: successColor,
            disabled: {
                backgroundColor: '#e9ecef',
            },
            hover: {
                backgroundColor: '#ffffff',
                borderColor: primaryColor,
                boxShadow: 'none',
                color: darkFontColor,
            },
            focus: {
                backgroundColor: `${primaryColor}0a`,
                borderColor: primaryColor,
                boxShadow: 'none',
                color: darkFontColor,
            },
            isValid: {
                backgroundColor: `${successColor}0a`,
                borderColor: successColor,
                boxShadow: 'none',
                color: darkFontColor,
            },
            isInvalid: {
                backgroundColor: `${dangerColor}1f`,
                borderColor: dangerColor,
                boxShadow: 'none',
                color: darkFontColor,
            },
        },
        formLabel: {
            color: '#1a1a1a80',
        },
        formCheck: {
            backgroundColor: '#ffffff',
            borderColor: '#1a1a1a33',
            knobColor: 'rgb(0, 0, 0)',
            hover: {
                backgroundColor: '#1a1a1a14',
                borderColor: '#1a1a1a1f',
                knobColor: 'rgb(0, 0, 0)',
            },
            focus: {
                backgroundColor: '#1a1a1a14',
                borderColor: '#1a1a1a33',
                knobColor: 'rgb(0, 0, 0)',
            },
            checked: {
                backgroundColor: `${primaryColor}99`,
                borderColor: '#1a1a1a33',
                knobColor: 'rgb(255, 255, 255)',
                hover: {
                    backgroundColor: primaryColor,
                    borderColor: '#1a1a1a33',
                    knobColor: 'rgb(255, 255, 255)',
                },
                focus: {
                    backgroundColor: `${primaryColor}99`,
                    borderColor: '#1a1a1a33',
                    knobColor: 'rgb(255, 255, 255)',
                },
            },
            isInvalid: {
                color: dangerColor,
            },
        },
        formRadio: {
            backgroundColor: '#ffffff',
            borderColor: '#1a1a1a33',
            knobColor: 'rgb(0, 0, 0)',
            hover: {
                backgroundColor: '#1a1a1a14',
                borderColor: '#1a1a1a1f',
                knobColor: 'rgb(0, 0, 0)',
            },
            focus: {
                backgroundColor: '#1a1a1a14',
                borderColor: '#1a1a1a33',
                knobColor: 'rgb(0, 0, 0)',
            },
            checked: {
                backgroundColor: `${primaryColor}99`,
                borderColor: '#1a1a1a33',
                knobColor: 'rgb(255, 255, 255)',
                hover: {
                    backgroundColor: primaryColor,
                    borderColor: '#1a1a1a33',
                    knobColor: 'rgb(255, 255, 255)',
                },
                focus: {
                    backgroundColor: `${primaryColor}99`,
                    borderColor: '#1a1a1a33',
                    knobColor: 'rgb(255, 255, 255)',
                },
            },
            isInvalid: {
                color: dangerColor,
            },
        },
        formSwitch: {
            backgroundColor: '#e1e2e34d',
            borderColor: '#1a1a1a1f',
            knobColor: 'rgb(0, 0, 0)',
            hover: {
                backgroundColor: '#1a1a1a14',
                borderColor: '#1a1a1a1f',
                knobColor: 'rgb(0, 0, 0)',
            },
            focus: {
                backgroundColor: '#e1e2e34d',
                borderColor: '#1a1a1a1f',
                knobColor: 'rgb(0, 0, 0)',
            },
            checked: {
                backgroundColor: `${primaryColor}99`,
                borderColor: '#1a1a1a1f',
                knobColor: 'rgb(255, 255, 255)',
                hover: {
                    backgroundColor: primaryColor,
                    borderColor: '#1a1a1a1f',
                    knobColor: 'rgb(255, 255, 255)',
                },
                focus: {
                    backgroundColor: `${primaryColor}99`,
                    borderColor: '#1a1a1a1f',
                    knobColor: 'rgb(255, 255, 255)',
                },
            },
            isInvalid: {
                backgroundColor: `${dangerColor}1f`,
                borderColor: dangerColor,
                knobColor: 'rgb(255, 147, 113)',
                color: dangerColor,
                hover: {
                    backgroundColor: `${dangerColor}`,
                    borderColor: dangerColor,
                    knobColor: 'rgb(255, 255, 255)',
                    color: dangerColor,
                },
            },
        },
        hr: {
            borderColor: '#1a1a1a33',
        },
        inputGroup: {
            background: secondaryColor,
            border: '1px solid #00000030',
            color: darkFontColor,
        },
        pagination: {
            backgroundColor: secondaryColor,
            borderColor: secondaryColor,
            color: `${darkFontColor}cc`,
            active: {
                backgroundColor: `${primaryColor}4d`,
                borderColor: secondaryColor,
                color: primaryColor,
            },
            disabled: {
                backgroundColor: `${secondaryColor}80`,
                borderColor: `${secondaryColor}80`,
                color: `${darkFontColor}cc`,
            },
            hover: {
                backgroundColor: secondaryColor,
                borderColor: secondaryColor,
                color: primaryColor,
            },
        },
        reactSelect: {
            backgroundColor: '#ffffff',
            borderColor: `${darkFontColor}33`,
            color: darkFontColor,
            focus: {
                backgroundColor: `${primaryColor}0a`,
                borderColor: primaryColor,
                color: darkFontColor,
            },
            hover: {
                borderColor: primaryColor,
            },
            invalid: {
                backgroundColor: `${dangerColor}1f`,
                borderColor: dangerColor,
            },
            menu: {
                borderColor: `${darkFontColor}14`,
            },
            multi: {
                backgroundColor: '#ffffff',
                borderColor: `${darkFontColor}33`,
                color: darkFontColor,
                hover: {
                    borderColor: darkFontColor,
                },
                remove: {
                    color: `${darkFontColor}80`,
                    hover: {
                        color: darkFontColor,
                    },
                },
            },
            option: {
                backgroundColor: 'transparent',
                color: `${darkFontColor}b2`,
                hover: {
                    backgroundColor: 'transparent',
                    borderColor: `${darkFontColor}14`,
                    color: darkFontColor,
                },
                isSelected: {
                    backgroundColor: `${primaryColor}0a`,
                    borderColor: primaryColor,
                    color: darkFontColor,
                },
            },
        },
        listGroupItem: {
            background: 'transparent',
            borderColor: '#00000030',
            color: darkFontColor,
        },
        loginNotice: {
            backgroundColor: infoColor,
            color: lightFontColor,
            boxShadowColor: '#a9a9a9',
        },
        modal: {
            backgroundColor: '#ffffff',
            boxShadow:
                'rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(26, 26, 26, 0.3) 0px 8px 12px 0px;',
            borderRadius: '5px',
            color: darkFontColor,
        },
        nav: {
            backgroundColor: '#1A1A1A',
            borderRight: 'solid 1px #1A1A1A',
            color: 'rgba(225, 226, 227, 0.8)',
            hover: {
                color: lightFontColor,
                background: '#D6D6D6',
            },
            active: {
                background: 'linear-gradient(93.99deg, rgba(95, 97, 255, 0.2) 0%, rgba(95, 97, 255, 0.008) 100%)',
                boxShadow: '0px 14px 20px rgba(95, 97, 255, 0.3)',
                borderImageSource: 'linear-gradient(183.99deg, rgba(95, 97, 255, 0.04) 49.04%, #5F61FF 100%)',
                color: lightFontColor,
            },
            disabled: {
                color: 'rgba(225, 226, 227, 0.5)',
            },
            dropdownMenu: {
                background: '#1A1A1A',
                color: lightFontColor,
                active: {
                    background: '#1A1A1A',
                    color: lightFontColor,
                    fontWeight: '600',
                },
                hover: {
                    background: '#1A1A1A',
                    color: lightFontColor,
                    fontWeight: '400',
                },
            },
            separator: {
                borderColor: 'rgba(225, 226, 227, 0.2)',
            },
        },
        navPills: {
            background: 'transparent',
            border: `3px solid ${primaryColor}`,
            color: primaryColor,
        },
        navTabs: {
            backgroundColor: 'transparent',
            borderColor: `${darkFontColor}14`,
            navLink: {
                backgroundColor: 'transparent',
                color: `${darkFontColor}cc`,
                active: {
                    borderColor: primaryColor,
                    color: darkFontColor,
                },
                hover: {
                    color: darkFontColor,
                },
            },
        },
        pdf: {
            textColor: '#000',
        },
        popover: {
            backgroundColor: '#ffffff',
            borderColor: '#1a1a1a14',
            navItem: {
                active: {
                    backgroundColor: `${primaryColor}0a`,
                    borderColor: primaryColor,
                    color: darkFontColor,
                },
                disabled: {
                    color: `${darkFontColor}80`,
                },
            },
        },
        pre: {
            backgroundColor: '#F5F5F5',
        },
        progressBar: {
            backgroundColor: primaryColor,
            color: lightFontColor,
        },
        sideMenu: {
            background: '#FFFFFF',
            borderLeft: '1px solid lightgrey',
            boxShadow: '0px 0px 0px 1px #EEEEEE',
            borderRadius: '0px',
            color: darkFontColor,
        },
        systemInfo: {
            background: '#0c0b0e',
            color: lightFontColor,
            button: {
                primary: {
                    background: successColor,
                    border: `1px solid ${successColor}`,
                },
                secondary: {
                    background: infoColor,
                    border: `1px solid ${infoColor}`,
                },
            },
        },
        table: {
            backgroundColor: 'transparent',
            borderColor: 'darkgrey',
            color: darkFontColor,
            header: {
                backgroundColor: `${darkFontColor}14`,
                borderColor: 'darkgrey',
                color: `${darkFontColor}cc`,
            },
            input: {
                backgroundColor: 'white',
                borderColor: 'grey',
                boxShadowColor: darkFontColor,
                color: darkFontColor,
            },
            active: {
                backgroundColor: 'blue',
                borderColor: 'blue',
                color: lightFontColor,
            },
            hover: {
                backgroundColor: `${primaryColor}14`,
                color: darkFontColor,
                borderColor: primaryColor,
            },
            highlight: {
                background: primaryColor,
                border: `1px solid rgba(255, 255, 255, 0.9)`,
                color: lightFontColor,
            },
        },
        tabs: {
            background: '#FFFFFF',
            borderBottom: '1px solid lightgrey',
            borderLeft: '1px solid lightgrey',
            borderRadius: '0px 0px 5px 5px',
            borderRight: '1px solid lightgrey',
            boxShadow: '0px 0px 0px 1px #EEEEEE',
            color: darkFontColor,
            active: {
                boxShadow: '-1px 0px 0px 0px #EEEEEE',
            },
        },
        terminals: {
            backgroundColor: '#1a1a1a',
            color: lightFontColor,
        },
        text: {
            primary: {
                color: primaryColor,
            },
            secondary: {
                color: secondaryColor,
            },
            success: {
                color: successColor,
            },
            danger: {
                color: dangerColor,
            },
            warning: {
                color: warningColor,
            },
            info: {
                color: infoColor,
            },
            muted: {
                color: `${darkFontColor}80`,
            },
        },
    },
    sansSerifFonts: ['DM Sans', 'sans-serif'],
    monospaceFonts: ['Share Tech Mono', 'monospace'],
    fontSizes: {
        small: '1em',
        medium: '2em',
        large: '3em',
    },
    images: {
        aboutLogo: 'cipher-insights-from-keyfactor-logo.png',
        aboutLogoImgAlt: 'CipherInsights from Keyfactor',
        favicon: 'keyfactor-favicon.jpg',
        logoImgAlt: 'CipherInsights',
        logo: 'cipher-insights-white.svg',
        secondaryLogo: 'cipher-insights-logo.png',
        loginLogo: 'cipher-insights-from-keyfactor-logo.png',
        pdfCoverLogo: 'cipher-insights-from-keyfactor-logo.png',
    },
}
